<template>  
    <section>
		<ul>
			<li class="info-wrap info-g">
				<span class="tou-xiang">头像</span>
                <div class="logo-icon" @click="uploadImg">
                    <img :src="userIcon"  alt="" class="logo" v-show="userInfo.user_icon"/>
                    <!-- <img src="../../assets/images/personal/pic_head_bg.png"  alt="" class="logo" v-show="!userInfo.user_icon"/> -->
                    
                    <div class="user-logo" v-show="!userInfo.user_icon"></div>
                    <span class="arrow"></span>
                </div>

                <div style="display:none">
                    <input type="file" accept="image/*" @change="onFileChanged" ref="input"/>
                </div>

			</li>
			
			<li class="info-wrap info-h" @click='navigateTo("user_name")'>
				<span class="tou-xiang">名称</span>
				<span class="info-value">{{userInfo.user_name}}</span>
			</li>
			
			<li class="info-wrap info-h">
				<span class="tou-xiang">手机号</span>
				<span class="info-value mobile-val">{{userInfo.account}}</span>
			</li>
			
			<li class="info-wrap info-h" @click='navigateTo("qq")'>
				<span class="tou-xiang">QQ号</span>
				<span class="info-value">{{userInfo.qq}}</span>
			</li>
		</ul>
			
		<div class="info-wrap info-h info-m no-border" @click='navigateTo("wangwang")'>
			<span class="tou-xiang">旺旺号</span>
			<span class="info-value">{{userInfo.wangwang}}</span>
		</div>
		
		<div class="btn-wrap">
			<div class="btn" @click="backMy">返回列表</div>
		</div>
    </section>
</template>

<script>
    import CommonHeader from '@/components/CommonHeader'
    import imageUpload from '@/components/ImageUpload';
    import ImageCompressor from 'image-compressor.js';
    import utils from '@/assets/jslibs/utils'
    import {getUserInfo, uploadImg, getCommunal,modifyUserInfo} from '@/api/common'
    export default {
        name: 'index',
		data(){
			return{
				imgUrl:this.$store.state.imgUrl || sessionStorage.getItem("imgUrl"),
				userInfo:{},
                isMobile:utils.isMobile(),
			}
		},
        components: {
            CommonHeader,
            imageUpload
        },
        
		beforeCreate(){
			sessionStorage.setItem("roleType","customer")
		},
		
        created() {
			this.getUserInfo();
            this.toast = this.$createToast({
              txt: '上传中...',
              mask: true,
            });
        },
        
        mounted(){
            document.title = "个人信息"
        },
      computed: {
        userIcon(){
          return this.httpFilterFUN(this.userInfo.user_icon) ? this.userInfo.user_icon : this.imgUrl + this.userInfo.user_icon
        }
      },
        methods: {
			//获取用户信息
			async getUserInfo(){
			    const { data, status } = await getUserInfo();
			    if (status !== 200) return 
			    this.userInfo = data;
				sessionStorage.setItem("userInfo",JSON.stringify(this.userInfo));
			},
            
            onFileChanged(event) {
              const file = event.target.files[0];
            
              if (!file) return;
            
              new ImageCompressor(file, {
                quatity: this.quatity,
                success: result => {
                  this.upload(result);
                },
                error: error => {
                  this.$createToast({ txt: error.message, time: 1500 }).show();
                },
              });
            
              this.toast.show();
            },
            
            async upload(file) {
             //首先获取七牛信息
                const { data, status } = await getCommunal();
                if (status !== 200) return 
            	this.imgUrl = data.BucketDomain;
                const formData = new FormData();
                formData.append('token', data.token)
                formData.append('file', file);
                const res = await uploadImg(formData).catch(() => {});
                this.toast.hide();
                if (res.status === 200) {
                    this.userInfo.user_icon = res.data.hash;
                    this.modifyUserInfo()
                    console.log(this.icon_images, '图片列表更新')
                }else{
                    window.toast("上传失败","txt");
                }
            },
            
            // 修改图像
            async modifyUserInfo(){
                let obj={user_icon:this.userInfo.user_icon,user_name:this.userInfo.user_name,qq:this.userInfo.qq,wangwang:this.userInfo.wangwang};
                const { data, status } = await modifyUserInfo(this.userInfo.uuid,obj);
                if (status !== 200) return 
                this.getUserInfo();
            },
            
            uploadImg(){
                // if(this.isMobile!=3){
                //     return
                // }
                this.$refs.input.click();
            },
            
            navigateTo(flag){
                this.$router.push({path:"./edit-data",query:{uuid:this.userInfo.uuid,flag:flag}})
            },

          httpFilterFUN(valueStr) {
            if (valueStr != "" && valueStr != null) {
              if (valueStr.indexOf("www") >= 0 || valueStr.indexOf("http") >= 0 || valueStr.indexOf("https") >= 0) {
                return true;
              } else {
                return false;
              }
            } else {
              return false;
            }
          },
			
			backMy(){
				sessionStorage.setItem("peg",3);
				sessionStorage.setItem("stamp","person");
				this.$router.push({path:'./index'})
			}
        },
    }
</script>

<style lang='less' scoped>
	@import '~@/assets/styles/variable.less';
	@import '~@/assets/styles/handleMethods.less';
	@import '~@/assets/styles/reset.css';

    section{font-family:PingFangSC-Regular;font-weight:400;background: #F5F5F5}
	.info-wrap{border-bottom:1px solid #F6F6F6;background: #fff;padding-left: 22px;padding-right: 23px;display: -webkit-box;display: -ms-flexbox;display: flex;justify-content: space-between;align-items: center}
    .tou-xiang{color:rgba(51,51,51,1);font-size: 15px}
	.logo-icon{display: flex;align-items:center}
	.logo{width: 50px;height: 50px;border-radius: 50%;padding:11px 0px 12px 0px;box-sizing: content-box;margin-right: 6px}
	.user-logo{width: 50px;height: 50px;margin: 0 auto;background: url(../../assets/images/personal/pic_head_bg.png) no-repeat center center;background-size: cover}
	.arrow{display: inline-block;width: 6px;height: 10px;margin-left: 6px;background: url(../../assets/images/home/ic_home_enter.png) no-repeat center center;background-size: cover}
	.info-h{height: 49px}
	.info-g{height: 72.5px}
	.info-m{margin-top: 11px}
	.no-border{border: none}
	.info-value{height: 22px;padding-right: 15px;color:rgba(51,51,51,1);font-size: 14px;background: url(../../assets/images/home/ic_home_enter.png) no-repeat right center;background-size: 6px}
	.mobile-val{background:none;padding-right:0;}
	.btn-wrap{position: absolute;left: 108px;bottom: 30px;background: #fff;}
	.btn{
    width: 160px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    border-radius: 8px;
    border: 1px solid rgba(193,193,193,1);
    font-size: 14px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: rgba(51,51,51,1);
    margin: 0 auto;}
</style>
